export default {"src":"/_next/static/media/ic_back_arrow.67bb2333.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};